import React from 'react'
import "./login.scss"
import axios from "axios";
import { useState } from "react";
import { useAuth} from "../../provider/authProvider";
import { useNavigate } from "react-router-dom";

const Login = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const { setToken } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const res = await axios.post("/api/auth/login", { username, password });
            if(res.status === 200) {
                setToken(res.data.accessToken)
                navigate("/", { replace: true });
            }
        } catch (err) {
            console.log(err);
        }
    };

    return (
        <div className='login'>
            <form onSubmit={handleSubmit}>
                <span className="formTitle">FDT Login</span>
                <input
                    type="text"
                    placeholder="username"
                    onChange={(e) => setUsername(e.target.value)}
                />
                <input
                    type="password"
                    placeholder="password"
                    onChange={(e) => setPassword(e.target.value)}
                />
                <button type="submit" className="submitButton">
                    Login
                </button>
            </form>
        </div>
    )
}

export default Login